<template>
  <div>
    <!-- <b-row
      class="text-center"
      v-if="
        occurrence &&
        occurrence.attachments != null &&
        occurrence.attachments.length > 0
      "
    > -->
    <b-row v-if="attachments != null">
      <b-col
        v-for="attachment in attachments"
        :key="attachment.attachmentId"
      >
        <!-- {{ attachment }} -->
        <base-attachment-item
          :attachment="attachment.attachmentContent"
          :discard-visible="false"
          @discard="null"
        >
        </base-attachment-item>
      </b-col>
      <!-- <b-col md="6" v-for="(attachment, i) in occurrence.attachments" :key="i">
        <base-attachment-item
          :attachment="attachment.attachmentContent"
          :discard-visible="false"
          @discard="null"
        >
        </base-attachment-item>
      </b-col> -->
    </b-row>
    <!-- <b-row
        v-for="(attachment, rowAttachment) in occurrence.attachments"
        :key="rowAttachment"
      >
        <b-col>
          <a href="#" @click.prevent="openImage(attachment.attachmentContent)">
            <img
              :src="attachment.attachmentContent"
              style="width: 100%"
              class="mb-2"
            />
          </a>
        </b-col>
      </b-row> -->
    <fullscreen-sidebar ref="fullscreenSidebar">
      <template v-slot:content>
        <img :src="attachmentUrl" class="fullscreen-sidebar-img" />
      </template>
    </fullscreen-sidebar>
    <!-- <div>{{ attachments }}</div> -->
    <!-- <div>this.model.occurrences: {{this.model.occurrences}}</div> -->
    <!-- <div>occurrenceTypeId: {{occurrenceTypeId}}</div> -->
  </div>

  <!-- <div>occurrence: {{occurrence}}</div> -->
</template>

<script>
import BaseAttachmentItem from "@/components_rms/base/BaseAttachmentItem.vue";
import FullscreenSidebar from "@/components_rms/FullscreenSidebar.vue";

export default {
  name: "CargoCrudStatusWaitingUnload",
  components: {
    BaseAttachmentItem,
    FullscreenSidebar,
  },
  props: {
    model: Object,
    readonly: Boolean,
    occurrenceTypeId: Number,
  },
  data() {
    return {
      attachmentUrl: "",
      attachments: [],
    };
  },
  created() {
    this.occurrence();
  },
  computed: {
    // occurrence() {
    //   if (!this.occurrenceTypeId) return null;
    //   if (!this.model) return null;
    //   if (this.model == null) return null;
    //   if (!this.model) return null;
    //   if (this.model.occurrences == null) return null;
    //   let items = this.model.occurrences;
    //   // console.log(items)
    //   items.forEach((item) => {
    //     // console.log(item);
    //     if (item.occurrenceTypeId == this.occurrenceTypeId) {
    //       if (item.attachments.length > 0) {
    //         this.attachments.push(item);
    //         // return item;
    //       }
    //     }
    //   });
    //   // for (let occurrenceTemp of this.model.occurrences) {
    //   //   // console.log(`occurrenceTypeId: ${this.occurrenceTypeId}`);
    //   //   console.log(`occurrenceTemp:`);
    //   //   console.log(occurrenceTemp);
    //   //   // console.log(`occurrenceTemp.occurrenceTypeId: ${occurrenceTemp.occurrenceTypeId}`);
    //   //   if (occurrenceTemp.occurrenceTypeId == this.occurrenceTypeId) {
    //   //     console.log("encontrou");
    //   //     return occurrenceTemp;
    //   //   }
    //   // }
    //   return null;
    // },
  },
  methods: {
    async loadImg() {
      if (this.model) {
        this.$api
          .request({
            url: `${this.$store.state.urlTracking}/v1/cargo/attachment/${this.model.cargoId}/11`,
            method: "GET",
            responseType: "arraybuffer", //important
          })
          .then((response) => {
            this.attachmentUrl = window.URL.createObjectURL(
              new Blob([response.data], {
                type: response.headers["content-type"],
              })
            );
          })
          .catch((error) => {
            console.log(error);
            console.log(error.response.data.errors);
            if (error.response.status == 400) {
              console.log(error.response.data.errors);
            }
          });
      }
      return "";
    },
    openImage(attachment) {
      this.attachmentUrl = attachment;
      this.$refs.fullscreenSidebar.open();
    },
    occurrence() {
      if (!this.occurrenceTypeId) return null;
      if (!this.model) return null;
      if (this.model == null) return null;
      if (!this.model) return null;
      if (this.model.occurrences == null) return null;
      let items = this.model.occurrences;
      // console.log(items)
      items.forEach((item) => {
        // console.log(item);
        if (item.occurrenceTypeId == this.occurrenceTypeId) {
          if (item.attachments.length > 0) {
            item.attachments.forEach((attachment) => {
              this.attachments.push(attachment);
              this.$forceUpdate();
            });
          }
        }
      });
    },
  },
};
</script>
